define('mmd.common.no_ui_login_register',function(require, exports, module){
    var $ = require('zepto');
    var cookie = require('commonjs/cookie');
    var default_config = {
        beforerequest:function(){},
        phoneid:'',
        getcodeid:'',
        codeid:'',
        submitbtnid:'',
        imglayerid:'',
        imgid:'',
        imgcodeid:'',
        imgcodebtnid:'',
        success:function(){},
        fail:function(){}
    };
    //var detect_api_url = 'http://event.midea.com/mlogin/is_login';
    //var get_verify_code_url = 'http://event.midea.com/my/index/getverifycodeV2';
    //var getimageverifycode_url = 'http://event.midea.com/my/index/getimageverifycode';
    //var login_api_url = 'http://event.midea.com/mlogin/create_member_by_mobile';
    var detect_api_url = '/mlogin/is_login';
    var get_verify_code_url = '/my/index/getverifycodeV2';
    var getimageverifycode_url = '/my/index/getimageverifycode';
    var login_api_url = '/mlogin/create_member_by_mobile';

    var isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
    var no_ui_login_requesting = false;

    function start(incom_config){
        var config = $.extend(default_config,incom_config);
        make_request(detect_api_url,{},function(resp){
            if(!resp){
                config.fail({errcode:1,errmsg:'ajax error!'});
            }
            if(resp.errcode != 0){ // not login
                if(window.location.search.indexOf('appview=1') > -1){
                    console.log('JS call native Login');
                    try{
                        if(md && md.bridge){
                            console.log(2);
                            var cmdEntity = md.bridge.cmdEntityFactory.createDisplayLoginViewCmdEntity(null, function (response) {
                                console.log('response: ',response);
                                log('response: ', response);
                            });
                            console.log(cmdEntity);
                            md.bridge.bridgeAPI.sendCmd(cmdEntity);
                            return;
                        }
                    }catch(err) {
                        console.error(err);
                    }

                }
                login_api_url = resp.data.loginUrl;
                if(isWx && resp.errcode == 539299862){
                    window.location = login_api_url+encodeURIComponent(window.location.href);
                }else{
                    // 此处弹出浮层
                    config.beforerequest();
                    var hasImgVerifyDom = false;
                    if(config.imglayerid != '' && config.imgid != ''
                        && config.imgcodeid != '' && config.imgcodebtnid != ''){
                        hasImgVerifyDom = true;
                    }
                    bind_event(config,hasImgVerifyDom);
                }
            }else{
                config.success(resp);
            }
        });
    }

    function bind_event(config,has_img_verify_logic){
        has_img_verify_logic = has_img_verify_logic || false;
        var $phone_input = $('#'+config.phoneid);
        var $get_code_btn = $('#'+config.getcodeid);
        var $code_input = $('#'+config.codeid);
        var $submit_btn = $('#'+config.submitbtnid);

        if(has_img_verify_logic){
            var $img_layer = $('#'+config.imglayerid);
            var $img_pic = $('#'+config.imgid);
            var $img_code_input = $('#'+config.imgcodeid);
            var $img_code_btn = $('#'+config.imgcodebtnid);
            $img_layer.addClass('hide').hide();
            $img_code_input.val('');
        }

        $get_code_btn.off('click.no_ui_login').on('click.no_ui_login',function(e){
            if($get_code_btn.attr('data-disable')){
                return;
            }
            var phone_no = $.trim($phone_input.val());
            if(!is_phone_no(phone_no)){
                alert('请输入正确的手机号');
                return;
            }

            $get_code_btn.addClass('disable').attr('data-disable',1);
            var total=60;
            var timer=null;
            timer=setInterval(function(){
                if(total<=1){
                    clearInterval(timer);
                    $get_code_btn.removeClass('disable').removeAttr('data-disable').html('获取验证码');
                }else{
                    total--;
                    $get_code_btn.html(total+'s后再试');
                }
            },1000);
            // window.setTimeout(function(){
            //     $get_code_btn.removeClass('disable').removeAttr('data-disable');
            // },60*1000);

            make_request(get_verify_code_url,{
                mobile:phone_no,
                sceneid: isWx ? 2: 1
            },function(resp){
                if(resp.errCode == 539365412){
                    // 需要图片验证码
                    if(has_img_verify_logic){
                        $img_pic.attr("src",getimageverifycode_url+"?mobile=" + phone_no + "&t= "+ Math.random());
                        $img_layer.removeClass('hide').show();
                    }
                }else if(resp.errCode == 539365411){
                    // 图片验证码错误
                    if(has_img_verify_logic){
                        alert('图片验证码错误');
                        $img_pic.attr("src",getimageverifycode_url+"?mobile=" + phone_no + "&t= "+ Math.random());
                        $img_layer.removeClass('hide').show();
                    }
                }
            })
        });
        if(has_img_verify_logic){

            // 点击图片重刷验证码逻辑
            $img_pic.off('click.no_ui_login').on('click.no_ui_login', function (e) {
                var phone_no = $.trim($phone_input.val());
                if(!is_phone_no(phone_no)){
                    alert('请输入正确的手机号');
                    $img_layer.addClass('hide').hide();
                    return;
                }
                $img_pic.attr("src",getimageverifycode_url+"?mobile=" + phone_no + "&t= "+ Math.random());
            });


            // 输入图片验证码后点击确定
            $img_code_btn.off('click.no_ui_login').on('click.no_ui_login', function (e) {
                var phone_no = $.trim($phone_input.val());
                if(!is_phone_no(phone_no)){
                    alert('请输入正确的手机号');
                    $img_layer.addClass('hide').hide();
                    return;
                }
                var img_verify_code = $.trim($img_code_input.val());
                if(img_verify_code == ''){
                    alert('请输入图片验证码');
                    return;
                }

                // 发起请求时隐藏图片验证码浮层
                $img_layer.addClass('hide').hide();

                make_request(get_verify_code_url,{
                    mobile:phone_no,
                    strImageVerifyCode:img_verify_code,
                    sceneid: isWx ? 2: 1
                },function(resp){
                    if(resp.errCode == 539365412){
                        // 需要图片验证码
                        if(has_img_verify_logic){
                            $img_pic.attr("src",getimageverifycode_url+"?mobile=" + phone_no + "&t= "+ Math.random());
                            $img_layer.removeClass('hide').show();
                        }
                    }else if(resp.errCode == 539365411){
                        // 图片验证码错误
                        if(has_img_verify_logic){
                            alert('图片验证码错误');
                            $img_pic.attr("src",getimageverifycode_url+"?mobile=" + phone_no + "&t= "+ Math.random());
                            $img_layer.removeClass('hide').show();
                            $img_code_input.val('');
                        }
                    }
                })
            })
        }

        $submit_btn.off('click.no_ui_login').on('click.no_ui_login',function (e) {
            var phone_no = $.trim($phone_input.val());
            if(!is_phone_no(phone_no)){
                alert('请输入正确的手机号');
                return;
            }

            var verify_code = $.trim($code_input.val());
            if(verify_code == ''){
                alert('请输入验证码');
                return;
            }
            if(no_ui_login_requesting){
                return;
            }

            no_ui_login_requesting = true;
            make_request(login_api_url,{
                mobile:phone_no,
                verifycode:verify_code,
                reqtype:1
            },function(resp){
                if(resp.errcode != 0){
                    if(resp.errmsg){
                        alert(resp.errmsg);
                    }
                }else{
                    if(resp.data && resp.data.uid){
                        var domain='.'+ location.host.split('.').slice(-2).join('.');
                        cookie.setC('uid',resp.data.uid,30*24*60,'/',domain);
                        cookie.setC('sukey',resp.data.sukey,30*24*60,'/',domain);

                    }
                    // 只上报数据，不跳转
                    window.report_ocpm && typeof window.report_ocpm == 'function' && window.report_ocpm();

                    config.success(resp);
                }
            },function(){
                config.fail();
            },function(){
                no_ui_login_requesting = false;
            })
        });
    }

    function is_phone_no(phone){
        if(/^1\d{10}$/.test(phone)){
            return true;
        }
        return false;
    }

    function make_request(url,data,success_cb,error_cb,complete_cb){
        data = data || {};
        success_cb = success_cb || function(){};
        error_cb = error_cb || function(){};
        complete_cb = complete_cb || function(){};

        $.ajax({
            type: 'GET',
            url: url,
            data: data,
            dataType: 'json',
            timeout: 10000,
            cache: false,
            xhrFields: {
                withCredentials: true
            },
            beforeSend: function(xhr){
                xhr.withCredentials = true;
            },
            success: function (response) {
                success_cb(response);
            },
            error: function (a,b,c) {
                error_cb(a,b,c)
            },
            complete: function (xhr, status) {
                //if (status == 'timeout') {
                //    console.log('超时了，请重试');
                //}
                complete_cb();
            }
        })
    }
    exports.init = function(){
        return {
            start:start
        };
    }
});


// WEBPACK FOOTER //
// ./../common/js/mmd.common.no_ui_login_register.js